import {
  artifactQualityMessage,
  exportDelivery,
  exportUnitMessage,
  heldArtifactEntries,
} from "../../utils/artifactQuality";

/** Owner-only latest-attempt evidence; never render this on token-shared pages.
 * @param {{doc: Record<string, any>}} props
 */
export default function ExportDeliveryNotice({ doc }) {
  const delivery = exportDelivery(doc);
  const units = delivery?.units.filter((/** @type {any} */ unit) => unit.status === "held") || [];
  // Ordinary/manual publishes may have quality evidence but no paid-unit
  // settlement. Explain the withheld file without inventing any refund.
  const covered = new Set(units.flatMap((/** @type {any} */ unit) => unit.outputs));
  const held = heldArtifactEntries(doc).filter(([key]) => !covered.has(key));
  if (!units.length && !held.length) return null;
  /** @type {Record<string, string>} */
  const labels = {
    report_pdf: "Listing Strategy PDF",
    deck: "Seller Presentation PDF",
    pptx: "PowerPoint",
    one_pager: "One-pager",
  };
  return (
    <section aria-label="Export status" aria-live="polite">
      <p>Your listing analysis is available. Some files need attention.</p>
      {units.map((/** @type {any} */ unit) => (
        <p key={unit.artifact}>{exportUnitMessage(unit)}</p>
      ))}
      {held.map(([key, artifact]) => (
        <p key={key}>
          {labels[key] || "Export"}: {artifactQualityMessage(artifact, key)}
        </p>
      ))}
      <p>Review available files before sharing. No new export is started automatically.</p>
    </section>
  );
}
